import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import React, { useRef } from 'react';

import Geo from './Geo';
import Geomagnetic from './Geomagnetic';
import styles from './index.module.scss';
import SunTimes from './SunTimes';
import TimeClock from './TimeClock';
import Weather from './Weather';

import Bar from '@/components/ui/Bar';

const cx = classNames.bind(styles);

const BottomBar = () => {
  const containerRef = useRef(null);

  useMountEffect(() => {
    const container = containerRef.current;
    // 숨김 우선순위
    const selectors = [
      '[data-hide-priority="1"]', // Geomagnetic
      '[data-hide-priority="2"]', // MGRS
      '[data-hide-priority="3"]', // Sunrise & Sunset
      '[data-hide-priority="4"]', // Pressure
    ];

    const handleResize = () => {
      // 모든 항목 표시
      selectors.forEach((selector) => {
        const element = container.querySelector(selector);
        if (element) {
          element.style.display = '';
        }
      });

      // 오버플로우 확인 및 순차적 숨김
      selectors.forEach((selector) => {
        if (container.scrollWidth > container.clientWidth) {
          const element = container.querySelector(selector);
          if (element) {
            element.style.display = 'none';
          }
        }
      });
    };

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(container);
    handleResize(); // 초기 실행

    return () => resizeObserver.disconnect();
  });

  return (
    <div ref={containerRef} className={cx('container')}>
      <Weather />
      <SunTimes />
      <Geomagnetic />
      <Bar size={28} />
      <Geo />
      <TimeClock />
    </div>
  );
};

export default BottomBar;
